import { LogLevel } from "@azure/msal-browser";
import AzureConstant from "./authConfigConstant";

let CLIENT_ID = AzureConstant.DEV_CLIENT;
let TENANT_ID = AzureConstant.TENANT_ID;
let RETURN_URL = AzureConstant.LOCAL_APP;

if (window.location.href.includes(AzureConstant.DEV_APP)) {
  RETURN_URL = AzureConstant.DEV_APP;
}
if (window.location.href.includes(AzureConstant.QA_APP)) {
  CLIENT_ID = AzureConstant.QA_CLIENT;
  RETURN_URL = AzureConstant.QA_APP;
}
if (window.location.href.includes(AzureConstant.CT_APP)) {
  CLIENT_ID = AzureConstant.CT_CLIENT;
  RETURN_URL = AzureConstant.CT_APP;
}

if (window.location.href.includes(AzureConstant.PROD_APP)) {
  CLIENT_ID = AzureConstant.PROD_CLIENT;
  RETURN_URL = AzureConstant.PROD_APP;
}

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID, //"7ea99495-b3a1-42bc-ad21-61851476f131",
    authority: `https://login.microsoftonline.com/${TENANT_ID}/`,
    redirectUri: `/signin-oidc`,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        // switch (level) {
        //   case LogLevel.Error:
        //     console.error(message);
        //     return;
        //   case LogLevel.Info:
        //     console.info(message);
        //     return;
        //   case LogLevel.Verbose:
        //     console.debug(message);
        //     return;
        //   case LogLevel.Warning:
        //     console.warn(message);
        //     return;
        // }
      },
    },
  },
};

export const loginRequest = {
  scopes: [`api://${CLIENT_ID}/User.Login`],
};

export const graphConfig = {
  graphMeEndpoint: "Enter_the_Graph_Endpoint_Herev1.0/me",
};
